export enum RoleContactType {
  CGAM = 'CGAM',
  LAM = 'LAM',
  ORDER_UPDATE = 'ORDER_UPDA',
  VGAM = 'VGAM',
  GBDM = 'GBDM',
  GBDM_OEM = 'GBDM_OEM',
  USER_ADMINISTRATOR = 'CADMIN',
  NATIONAL_ACCOUNT_MANAGER = 'NAM',
  COUNTRY_MANAGER = 'CM',
  PSS = 'OADM'
}